import { Reducer } from 'redux';
import { IWordsState, TWordsActions, WORDS_LEMMAS_PENDING, WORDS_MERGE_LEMMAS, WORDS_SET_DATA, WORDS_SET_LOAD_FAILED, WORDS_SET_GENERATING, WORDS_SET_GENERATE_FAILED, WORDS_SET_NATIVE } from './types';

const initialState: IWordsState = {
	byAudioId: {},
	generating: {},
	loadFailed: {},
	generateFailed: {},
	lemmas: {},
	lemmasPending: {},
	native: {},
};

export const wordsReducer: Reducer<IWordsState, TWordsActions> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case WORDS_SET_DATA:
			return {
				...state,
				byAudioId: { ...state.byAudioId, [action.audioId]: action.data },
			};

		case WORDS_SET_GENERATING:
			return {
				...state,
				generating: { ...state.generating, [action.audioId]: action.generating },
			};

		case WORDS_MERGE_LEMMAS:
			return {
				...state,
				lemmas: {
					...state.lemmas,
					[action.langCode]: { ...state.lemmas[action.langCode], ...action.lemmas },
				},
			};

		case WORDS_LEMMAS_PENDING:
			return {
				...state,
				lemmasPending: {
					...state.lemmasPending,
					[action.langCode]: (state.lemmasPending[action.langCode] || 0) + action.delta,
				},
			};

		case WORDS_SET_GENERATE_FAILED:
			return {
				...state,
				generateFailed: { ...state.generateFailed, [action.audioId]: action.failed },
			};

		case WORDS_SET_LOAD_FAILED:
			return {
				...state,
				loadFailed: { ...state.loadFailed, [action.audioId]: action.failed },
			};

		case WORDS_SET_NATIVE:
			return {
				...state,
				native: { ...state.native, [action.audioId]: action.native },
			};

		default:
			return state;
	}
};
